// extracted by mini-css-extract-plugin
export default {"footerArea":"Footer_footerArea__JbJdU","nav":"Footer_nav__sXt1R","navLink":"Footer_navLink__6jJ4+"};